import React from 'react';
import Document from '../../Cell/Document';
import Number from '../../Cell/Number';
import Text from '../../Cell/Text';
import Chance from '../../Cell/Chance';
import DocumentList from '../../Cell/DocumentList';

const EdexcelGCSE = ({ row }) => {
  const {
    edexcelGcseColumnOne,
    edexcelGcseColumnTwo,
    edexcelGcseColumnThree,
    edexcelGcseColumnFourDocument,
    edexcelGcseColumnFiveDocument,
    edexcelGcseColumnSixDocument,
    edexcelGcseColumnSevenDocument,
    edexcelGcseColumnEight,
    edexcelGcseColumnNineDocument,
  } = row;
  return (
    <tr>
      <td>{edexcelGcseColumnOne}</td>
      <td>
        <Number
          block={{
            value: +edexcelGcseColumnTwo,
            displayAs: 'grade',
          }}
        />
      </td>
      <td>
        <Chance
          block={{
            text: edexcelGcseColumnThree?.title?.toLowerCase().split(' ').join('-'),
          }}
        />
      </td>
      <td>
        <DocumentList documents={edexcelGcseColumnFourDocument} />
      </td>
      <td>
        <DocumentList documents={edexcelGcseColumnFiveDocument} />
      </td>
      <td>
        <DocumentList documents={edexcelGcseColumnSixDocument} />
      </td>
      <td>
        <DocumentList documents={edexcelGcseColumnSevenDocument} />
      </td>
      <td>
        <Document document={edexcelGcseColumnNineDocument} />
      </td>
      <td>
        <Text
          block={{
            body: edexcelGcseColumnEight,
          }}
          isVideoExplanation
        />
      </td>
    </tr>
  );
};

export default EdexcelGCSE;
